import { render, staticRenderFns } from "./FFSqaComponent.vue?vue&type=template&id=299b9844&scoped=true"
import script from "./FFSqaComponent.vue?vue&type=script&lang=js"
export * from "./FFSqaComponent.vue?vue&type=script&lang=js"
import style0 from "./FFSqaComponent.vue?vue&type=style&index=0&id=299b9844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b9844",
  null
  
)

export default component.exports